import { Injectable, EventEmitter } from '@angular/core'
import { Http } from '@angular/http'

import { ShareProvider } from '../share-provider.enum'
import { ShareArgs } from '../share-args'
import { ShareFactory } from '../share-factory'

@Injectable()
export class ShareService {

  windowWidth = 500
  windowHeight = 400

  constructor(private http: Http) {

  }

  public share(type: ShareProvider, args: ShareArgs, popUpClosed: EventEmitter<ShareProvider>) {
    if (window && window.innerWidth <= 480) {
      args = Object.assign({}, args, { mobile: true })
    }

    const popUp = window.open(ShareFactory.createSharerUrl(type, args), 'newwindow', this.windowAttr)

    if (popUp) {
      const pollTimer = setInterval(() => {
        if (popUp.closed) {
          clearInterval(pollTimer)
          popUpClosed.emit(type)
        }
      }, 200)
    }
  }

  private get windowAttr() {
    return `width=${this.windowWidth}, height=${this.windowHeight}`
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share/share.service.ts